import { Chunk1 } from "./backgrounds/Chunk1";
import { Chunk2 } from "./backgrounds/Chunk2";
import { Chunk3 } from "./backgrounds/Chunk3";
import { Chunk4 } from "./backgrounds/Chunk4";
import { Chunk5 } from "./backgrounds/Chunk5";
import { Chunk6 } from "./backgrounds/Chunk6";

export const Background_Chunk1 = Chunk1;
export const Background_Chunk2 = Chunk2;
export const Background_Chunk3 = Chunk3;
export const Background_Chunk4 = Chunk4;
export const Background_Chunk5 = Chunk5;
export const Background_Chunk6 = Chunk6;
